module.exports = "../study/imgs/maps/Kanagawa/S8/WaterEnvironment/Chlmax/Kanagawa_Chlmax_GFDL_RCP85_Mid.png";